import type { IPolygonTool } from 'src/map-3d/shared';
import { polygonTableSVGElement } from './polygon-table-svg-element';

type ImportPolygonWithSVGLabelProps = {
  id: string;
  heapName: string;
  volumeCut: string | null;
  volumeFill: string | null;
  volumeNet: string | null;
  weightCut: string | null;
  weightFill: string | null;
  weightNet: string | null;
  geometry: string;
  polygonTool: IPolygonTool;
};

export const importPolygonWithSVGLabel = ({
  id,
  heapName,
  volumeCut,
  volumeFill,
  volumeNet,
  weightCut,
  weightFill,
  weightNet,
  geometry,
  polygonTool,
}: ImportPolygonWithSVGLabelProps) => {
  polygonTool.importWKT(
    geometry,
    id,
    {
      heapId: id,
      isHeap: true,
    },
    {
      svgLabel: polygonTableSVGElement({
        text: heapName,
        volumeCut,
        volumeFill,
        volumeNet,
        weightCut,
        weightFill,
        weightNet,
      }),
    },
    {
      polygonStyleOptions: {
        strokeColor: '#BADBFC',
        strokeThickness: 3,
        fillColor: '#72A0D366',
        fillOpacity: 0.4,
      },
    },
  );
};
